import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import { connect } from "react-redux";
import moment from "moment";
import { homeActions } from "actions";
import { Field, getFormSyncErrors, getFormValues, reduxForm } from "redux-form";
import {
  renderSelectField,
  renderTimeField,
} from "components/FormFields/FieldTypes";
import { Required } from "components/FormFields/validators";

const DoseReminderPopUp = (props) => {
  const {
    showDoseReminder,
    onCancel,
    getReminderTimeZones,
    reminderTimeZone,
    getReminderDates,
    formErrors,
    initialize,
    formValues,
    saveDoseReminder,
    resetDeleteCouponInfo,
    selectedInsurance,
    brandDetailsNew,
    savedDoseReminderInfo,
    timeFormats,
    deleteCoupon,
    resetSavedCouponInfo,
    selectedGenericItem,
    genericDetails,
    appQuantity,
    doseReminderDetails,
    getDoseReminderData,
    updateGTMDataLayer,
    organizationInfo,
  } = props;
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [time1Check, setTime1Check] = useState(true);
  const [time2Check, setTime2Check] = useState(false);
  const [time3Check, setTime3Check] = useState(false);
  const [saveStarted, setSaveStarted] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  useEffect(() => {
    updateGTMDataLayer({
      event: "Get_savings_dose_reminder_attempt",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
      adjudicationId: brandDetailsNew?.id || genericDetails?.id,
      action: "attempting coupon dose reminder",
    });
    getReminderTimeZones();
    getReminderDates();
    if (
      brandDetailsNew &&
      brandDetailsNew?.productDetailId &&
      organizationInfo?.organizationOptionJson?.doseReminderFlag?.toLowerCase() ===
        "y"
    ) {
      getDoseReminderData(brandDetailsNew?.productDetailId);
    }
    if (
      genericDetails &&
      genericDetails?.productDetailId &&
      organizationInfo?.organizationOptionJson?.doseReminderFlag?.toLowerCase() ===
        "y"
    ) {
      getDoseReminderData(genericDetails?.productDetailId);
    }
  }, []);

  useEffect(() => {
    if (doseReminderDetails) {
      initialize({
        timeZone: doseReminderDetails.timeZone,
        time1: doseReminderDetails.time1
          ?.replace("am", "")
          .replace("pm", "")
          .trim(),
        time2: doseReminderDetails.time2
          ?.replace("am", "")
          .replace("pm", "")
          .trim(),
        time3: doseReminderDetails.time3
          ?.replace("am", "")
          .replace("pm", "")
          .trim(),
      });
      setTime1Check(doseReminderDetails.time1 ? true : false);
      setTime2Check(doseReminderDetails.time2 ? true : false);
      setTime3Check(doseReminderDetails.time3 ? true : false);
    } else {
      initialize({
        time1: "08:00",
      });
    }
  }, [doseReminderDetails]);

  useEffect(() => {
    if (savedDoseReminderInfo && savedDoseReminderInfo.success && saveStarted) {
      setShowSuccess(true);
      setShowFailure(false);
      setSaveStarted(false);
    } else if (
      savedDoseReminderInfo &&
      Object.keys(savedDoseReminderInfo).length &&
      savedDoseReminderInfo.success === false &&
      saveStarted
    ) {
      setShowSuccess(false);
      setShowFailure(true);
      setSaveStarted(false);
    }
  }, [savedDoseReminderInfo]);

  const isItAmOrPm = (timeString) => {
    let result = "";
    if (timeString) {
      const hourEnd = timeString.indexOf(":");
      const HourTime = timeString.substr(0, hourEnd);
      const hour = HourTime % 12 || 12;
      const ampm = HourTime < 12 ? "AM" : "PM";
      const hourCount = hour < 10 ? "0" + hour : hour;
      result = `${hourCount}${timeString.substr(hourEnd, 3)} ${ampm}`;
    }
    return result;
  };

  const onSubmitReminder = () => {
    const appData = JSON.parse(sessionStorage.getItem("applicationData"));
    const params = {
      time1: isItAmOrPm(formValues["time1"]) || null,
      time2: isItAmOrPm(formValues["time2"]) || null,
      time3: isItAmOrPm(formValues["time3"]) || null,
      timeZone: formValues["timeZone"],
      quantity: appQuantity || 0,
      startDate: moment().format("MM/DD/YYYY"),
      insuranceId: selectedInsurance.id,
      productDetailId: selectedGenericItem
        ? genericDetails?.productDetailId
        : brandDetailsNew?.productDetailId,
      pharmacyLocationId: selectedGenericItem
        ? selectedGenericItem?.pharmacyLocationId
        : -1,
      couponType:
        selectedGenericItem?.couponType || selectedGenericItem?.discountType,
      deviceId: appData?.device?.id,
      appUserId: appData?.appUser?.id,
      id: doseReminderDetails?.id || null,
    };
    setSaveStarted(true);
    saveDoseReminder(params);
    resetDeleteCouponInfo();
    updateGTMDataLayer({
      event: "Get_savings_dose_reminder",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
      ...params,
      action: "compelted coupon dose reminder",
    });
  };

  const onDeleteOptionClick = () => {
    setShowDeleteConfirm(true);
    setShowSuccess(false);
  };

  const onDelteCoupon = () => {
    setShowDeleteConfirm(false);
    setShowSuccess(false);
    onCancel();
    deleteCoupon(savedDoseReminderInfo?.data?.savedCouponId);
    resetSavedCouponInfo();
  };

  return (
    <>
      <Dialog open={showDoseReminder} className="app-dialog">
        <DialogContent sx={{ padding: matchesMinWidth ? "20px" : "40px" }}>
          <form>
            <Box px={matchesMinWidth ? 2 : 4} py={2}>
              {!showSuccess && !showFailure && !showDeleteConfirm ? (
                <Box>
                  <Box
                    mt={matchesMinWidth ? 0 : 2}
                    sx={{ textAlign: "center" }}
                  >
                    <Typography
                      variant="text2"
                      sx={{ fontSize: matchesMinWidth ? "1.25rem" : undefined }}
                    >
                      Daily dose reminders
                    </Typography>
                  </Box>
                  <Box mt={2} mb={2}>
                    <Typography
                      variant="text4"
                      sx={{ fontSize: matchesMinWidth ? "0.9rem" : undefined }}
                    >
                      Please Send dose reminders at these times:
                    </Typography>
                  </Box>
                  <Box mt={1} mb={3}>
                    <Field
                      name="timeZone"
                      isRequired
                      component={renderSelectField}
                      label="Select Time Zone"
                      validate={Required}
                      options={reminderTimeZone}
                    />
                  </Box>
                  <Box mb={2}>
                    <Typography variant="text4">Select Time of Day</Typography>
                    <Box mt={2}>
                      <Field
                        name="time1"
                        isRequired={time1Check}
                        type="time"
                        component={renderTimeField}
                        validate={time1Check ? Required : ""}
                        isChecked={time1Check}
                        onCheckBoxClick={() => {
                          setTime1Check(!time1Check);
                        }}
                      />
                    </Box>
                    <Box my={3}>
                      <Field
                        name="time2"
                        type="time"
                        component={renderTimeField}
                        validate={time2Check ? Required : ""}
                        isChecked={time2Check}
                        onCheckBoxClick={() => {
                          setTime2Check(!time2Check);
                        }}
                      />
                    </Box>
                    <Box>
                      <Field
                        name="time3"
                        type="time"
                        component={renderTimeField}
                        validate={time3Check ? Required : ""}
                        isChecked={time3Check}
                        onCheckBoxClick={() => {
                          setTime3Check(!time3Check);
                        }}
                      />
                    </Box>
                  </Box>
                  <Box
                    mt={6}
                    mb={3}
                    sx={{ textAlign: matchesMinWidth ? "center" : undefined }}
                  >
                    <Button
                      variant="large"
                      disabled={Object.keys(formErrors).length ? true : false}
                      onClick={() => onSubmitReminder()}
                      sx={{
                        fontSize: matchesMinWidth ? "14px" : undefined,
                        minWidth: matchesMinWidth ? "200px" : undefined,
                        backgroundColor:
                          formErrors && Object.keys(formErrors).length
                            ? "#e6e6e6"
                            : undefined,
                      }}
                    >
                      SAVE DOSE REMINDERS
                    </Button>
                  </Box>
                  <Box
                    mt={2}
                    sx={{ textAlign: matchesMinWidth ? "center" : undefined }}
                  >
                    <Button
                      variant="text"
                      onClick={onCancel}
                      sx={{
                        fontSize: matchesMinWidth ? "16px" : undefined,
                        minWidth: matchesMinWidth ? "200px" : undefined,
                      }}
                    >
                      CANCEL
                    </Button>
                  </Box>
                </Box>
              ) : (
                <Box sx={{ textAlign: "center" }}>
                  {showSuccess ? (
                    <Box>
                      <Box>
                        <Typography variant="h4LatoBlack">
                          Daily dose reminder
                        </Typography>
                      </Box>
                      <Box my={4}>
                        <Typography variant="h3LatoBlack">CONFIRMED</Typography>
                      </Box>
                      <Box mb={2}>
                        <Typography variant="h4LatoRegular">
                          We will send you notifications at these times:
                        </Typography>
                      </Box>
                      <Box mb={6}>
                        <Typography component="div" variant="h3LatoBlack">
                          {formValues.time1}{" "}
                          {formValues.time1
                            ? timeFormats[formValues.timeZone]
                            : ""}
                        </Typography>
                        <Typography
                          component="div"
                          variant="h3LatoBlack"
                          sx={{ marginTop: "8px", marginBottom: "8px" }}
                        >
                          {formValues.time2}{" "}
                          {formValues.time2
                            ? timeFormats[formValues.timeZone]
                            : ""}
                        </Typography>
                        <Typography component="div" variant="h3LatoBlack">
                          {formValues.time3}{" "}
                          {formValues.time3
                            ? timeFormats[formValues.timeZone]
                            : ""}
                        </Typography>
                        <br />
                      </Box>
                      <Box mb={3} mx="auto">
                        <Button
                          variant="text"
                          sx={{
                            width: "100%",
                            minWidth: matchesMinWidth ? "200px" : undefined,
                          }}
                          onClick={onDeleteOptionClick}
                        >
                          <Typography
                            variant="h3LatoBlack"
                            sx={{
                              textDecoration: "underline",
                            }}
                          >
                            Delete Reminder
                          </Typography>
                        </Button>
                      </Box>
                      <Box mb={4}>
                        <Button
                          variant="large"
                          sx={{
                            minWidth: matchesMinWidth ? "200px" : undefined,
                          }}
                          onClick={() => {
                            onCancel();
                            setShowSuccess(false);
                          }}
                        >
                          DONE
                        </Button>
                      </Box>
                    </Box>
                  ) : null}
                  {showFailure ? (
                    <Box>
                      <Box>
                        <Typography variant="text2" sx={{ fontSize: "25px" }}>
                          Dose Reminder Error
                        </Typography>
                      </Box>
                      <Box my={4}>
                        <Typography variant="text3">
                          {savedDoseReminderInfo.message}
                        </Typography>
                      </Box>
                      <Box>
                        <Button
                          variant="large"
                          sx={{
                            minWidth: matchesMinWidth ? "200px" : undefined,
                          }}
                          onClick={() => setShowFailure(false)}
                        >
                          DONE
                        </Button>
                      </Box>
                    </Box>
                  ) : null}
                  {showDeleteConfirm ? (
                    <Box>
                      <Box>
                        <Typography variant="h2LatoRegular">
                          Are you sure do you want to delete?
                        </Typography>
                      </Box>
                      <Box mb={2} mt={4}>
                        <Button
                          sx={{
                            minWidth: matchesMinWidth ? "200px" : undefined,
                          }}
                          variant="large"
                          onClick={onDelteCoupon}
                        >
                          DONE
                        </Button>
                      </Box>
                      <Box>
                        <Button
                          variant="text"
                          sx={{
                            minWidth: matchesMinWidth ? "200px" : undefined,
                          }}
                          onClick={() => {
                            setShowDeleteConfirm(false);
                            setShowSuccess(true);
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Box>
                  ) : null}
                </Box>
              )}
            </Box>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

function mapStateToProps(state) {
  return {
    reminderTimeZone: state.reminderTimeZone.data,
    timeFormats: state.reminderTimeZone.timeFormats,
    reminderDates: state.reminderDates.data,
    formErrors: getFormSyncErrors("REMINDER_POPUP_FORM")(state) || {},
    formValues: getFormValues("REMINDER_POPUP_FORM")(state),
    brandDetailsNew: state.brandDetailsNew.data || {},
    genericDetails: state.genericDetails.data,
    selectedInsurance: state.insuranceList.selectedInsurance || {},
    couponData: state.couponPrice.data,
    productDetailId: state.productDetails.productDetailId,
    zipData: state.zipData.data,
    savedDoseReminderInfo: state.savedDoseReminderInfo.data,
    doseReminderDetails: state.doseReminderDetails.data,
    appQuantity: state.productDetails.appQuantity,
    organizationInfo: state.organizationInfo.data,
  };
}

const mapDispatchToProps = {
  getReminderTimeZones: (params) => homeActions.getReminderTimeZones(params),
  getReminderDates: (params) => homeActions.getReminderDates(params),
  saveDoseReminder: (params) => homeActions.saveDoseReminder(params),
  deleteCoupon: (value) => homeActions.deleteCoupon(value),
  getDoseReminderData: (params) => homeActions.getDoseReminderData(params),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  resetSavedCouponInfo: (value) => homeActions.resetSavedCouponInfo(value),
  resetDeleteCouponInfo: () => homeActions.resetDeleteCouponInfo(),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "REMINDER_POPUP_FORM",
  })(DoseReminderPopUp)
);
